import React from "react";
import { formatDate, formatCurrency, warrantyStatus } from "../../utils/helpers";

export default function ProductTable({ products, onView, onEdit, onDelete, onGenerateCard }) {
  if (!products.length) {
    return (
      <div className="text-center py-16" style={{ color: "#5a4a30" }}>
        <svg className="mx-auto h-12 w-12 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414A1 1 0 0119 9.414V19a2 2 0 01-2 2z" />
        </svg>
        <p className="text-lg font-medium" style={{ color: "#8A6000" }}>No products found</p>
        <p className="text-sm">Add your first warranty entry to get started</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full text-sm" style={{ borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ background: "#111", borderBottom: "1px solid rgba(200,150,12,0.3)" }}>
            {["Warranty ID", "Customer", "Product", "Purchase Date", "Duration", "Status", "Price", "Actions"].map((h) => (
              <th key={h} className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-widest" style={{ color: "#C8960C" }}>
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {products.map((p, i) => {
            const { status } = warrantyStatus(p.purchaseDate, p.warrantyDurationMonths);
            return (
              <tr key={p._id}
                style={{
                  background: i % 2 === 0 ? "#1a1a1a" : "#161616",
                  borderBottom: "1px solid rgba(200,150,12,0.08)",
                  transition: "background 0.15s"
                }}
                onMouseEnter={e => e.currentTarget.style.background = "#222"}
                onMouseLeave={e => e.currentTarget.style.background = i % 2 === 0 ? "#1a1a1a" : "#161616"}
              >
                <td className="px-4 py-3 font-mono font-semibold whitespace-nowrap" style={{ color: "#FFD700" }}>
                  {p.warrantyId}
                </td>
                <td className="px-4 py-3 whitespace-nowrap">
                  <div className="font-medium" style={{ color: "#f5f0e8" }}>{p.customerName}</div>
                  <div className="text-xs" style={{ color: "#5a4a30" }}>{p.phoneNumber}</div>
                </td>
                <td className="px-4 py-3 max-w-[160px] truncate font-medium" style={{ color: "#d4c090" }}>{p.productName}</td>
                <td className="px-4 py-3 whitespace-nowrap" style={{ color: "#a09070" }}>{formatDate(p.purchaseDate)}</td>
                <td className="px-4 py-3 whitespace-nowrap" style={{ color: "#a09070" }}>{p.warrantyDuration}</td>
                <td className="px-4 py-3 whitespace-nowrap">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                    style={status === "Active"
                      ? { background: "rgba(74,124,78,0.2)", color: "#6fcf7f", border: "1px solid rgba(74,124,78,0.4)" }
                      : { background: "rgba(124,74,74,0.2)", color: "#cf6f6f", border: "1px solid rgba(124,74,74,0.4)" }
                    }>
                    <span className="w-1.5 h-1.5 rounded-full mr-1" style={{ background: status === "Active" ? "#6fcf7f" : "#cf6f6f" }} />
                    {status}
                  </span>
                </td>
                <td className="px-4 py-3 whitespace-nowrap font-medium" style={{ color: "#C8960C" }}>{formatCurrency(p.productPrice)}</td>
                <td className="px-4 py-3 whitespace-nowrap">
                  <div className="flex items-center gap-1">
                    <button onClick={() => onView(p)} title="View" className="p-1.5 rounded-lg transition-colors" style={{ color: "#C8960C" }}
                      onMouseEnter={e => e.currentTarget.style.background = "rgba(200,150,12,0.1)"}
                      onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                      </svg>
                    </button>
                    <button onClick={() => onGenerateCard(p)} title="Generate Card" className="p-1.5 rounded-lg transition-colors" style={{ color: "#6fcf7f" }}
                      onMouseEnter={e => e.currentTarget.style.background = "rgba(74,124,78,0.15)"}
                      onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0" />
                      </svg>
                    </button>
                    <button onClick={() => onEdit(p)} title="Edit" className="p-1.5 rounded-lg transition-colors" style={{ color: "#FFD700" }}
                      onMouseEnter={e => e.currentTarget.style.background = "rgba(200,150,12,0.1)"}
                      onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                      </svg>
                    </button>
                    <button onClick={() => onDelete(p)} title="Delete" className="p-1.5 rounded-lg transition-colors" style={{ color: "#cf6f6f" }}
                      onMouseEnter={e => e.currentTarget.style.background = "rgba(124,74,74,0.15)"}
                      onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
